// extracted by mini-css-extract-plugin
export default {"error":"Error404_error__kTRPA","image":"Error404_image__fxuQW"};